<template>
   <ul class="p-0 mt-2"  style="list-style-type:none;" v-if="isAlumni">

        <li v-for="(file, index) in files"
            :key="index">

            <span v-if="file.timestamp">{{file.timestamp}} |</span>

            <a  v-if="!file.timestamp && !file.path" @click.prevent="downloadApplication(file , true)" class="mr-2 text-primary">{{file.split('/').pop()}}</a>
            <a  v-else @click.prevent="downloadApplication(file.path , true)">{{file.path.split('/').pop()}} </a>
                    |
            <a v-if="!file.timestamp && !file.path" @click.prevent="downloadApplication(file)" class="ml-2 text-primary">{{$t('button.view')}}</a>
            <a v-else @click.prevent="downloadApplication(file.path)" class="ml-2 text-primary">{{$t('button.view')}}</a>

        </li>
    </ul>

    <ul class="p-0 mt-2" v-else>
        <li v-for="(file, index) in files"
            :key="index" class="d-flex justify-content-between">
            <div>

                <a href="#"
                    @click.prevent="downloadApplication(file , true)">{{$t('button.download')}}</a>
                    |
                <a href="#"
                    @click.prevent="downloadApplication(file , false)">{{$t('button.view')}}</a>
            </div>
            <a href="#" v-if="!readonly"
                @click.prevent="removeApplicationFile(index,file, 'Degree')"
                class="text-danger"
                :title="$t('form.student.remove')">X</a>
        </li>
    </ul>
</template>

<script>
export default {
    props:['files','isAlumni','readonly'],
    methods:{

           async createToken() {
                let response = await axios.post('/api/api-tokens', {
                    type: 'alumni-attachment'
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },
         async downloadApplication(file , isDownload = false) {
                let token = await this.createToken('student-application');

                if (token == '') return;

                let encodedFilePath = encodeURIComponent(file);

                window.open(`/students/applications?file=${encodedFilePath}&token=${token}&download=${isDownload}`, '_blank');
            },

            removeApplicationFile(index, attach, type = null) {
                let vm = this;

                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/students/application/delete", attach)
                        .then(response => {

                            if (response.data.error) {
                                this.showAlert(response.data.message, 'warning');
                            } else if (response.data.success) {
                                vm.files.splice(index, 1);
                                this.showAlert(response.data.message);
                            }

                        })
                        .catch(error => {
                            console.log('error');
                        });
                }
            },
    }

}
</script>

<style>

</style>
